






















import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import { getEmail } from '@/utils/cookie';
import { SubjectBlock } from '@/views/Subjects.vue';

@Component({
  components: {
    Modal,
  },
})
export default class ModalSubjectNotAvail extends Vue {
  @Prop()
  showSubjectNotAvailModal!: boolean;

  @Prop()
  closeSubjectNotAvail!: () => void;

  @Prop()
  selectedSubject!: SubjectBlock;

  @Prop()
  selectedSubjectlabel!: string;

  get userEmail() {
    return getEmail();
  }

  get subjectName() {
    return this.selectedSubject ? this.selectedSubject.name : '';
  }

  get subjectlabel() {
    return this.selectedSubjectlabel ? this.selectedSubjectlabel : '';
  }

  get formSrc() {
    return `https://docs.google.com/forms/d/e/1FAIpQLSetIYYwFa_Im9lx-6eokp6ZqWB6Zxp0HbMPk-hbi1b2Zf0cLA/viewform?usp=pp_url&entry.599702293=${
      this.subjectName
    } (${this.subjectlabel})&entry.732831280=${
      this.userEmail ? this.userEmail : ''
    }`;
  }

  get title() {
    return `${this.subjectName} for ${this.subjectlabel} is coming soon`;
  }

  width = '800px';

  description = `We are still creating questions for this subject.
  But we understand that you need them ASAP.
  So, to speed up the process of creating questions for this subject,
  you can fill the form below, so that we can prioritize it 💪`;
}
